import { Injectable } from '@angular/core';

import { getRedirectedUrl } from '@blaze-shared/platform-util';

@Injectable()
export class StaticRedirectGuardService {
  // CanLoad runs before CanActivate
  canLoad(): boolean {
    const url = new URL(globalThis.location.href);

    // Is system-initiated redirect (not a static redirect). Remove hash and continue without redirection.
    if (url.hash === '#dashboard' && (!url.pathname || url.pathname === '/')) {
      url.hash = '';
      const href = url.href.endsWith('/') ? `${url.href}projects` : `${url.href}/projects`;
      console.log(`Redirecting to ${href}`);
      globalThis.location.href = href;
    }

    const redirectUrl = getRedirectedUrl(globalThis.location.href);
    if (redirectUrl) {
      console.log(
        `Current URL found in the list of static redirects. Redirecting to ${redirectUrl}`,
      );
      globalThis.location.href = redirectUrl;
      return false;
    }
    return true;
  }
}
